// src/api/commentApi.ts
import axios from 'axios';
import { CommentItem } from '../types/commentTypes';

export const commentApi = {
    getComments: async (boardId: number): Promise<CommentItem[]> => {
        const response = await axios.get(`/api/comment/${boardId}`);
        return response.data;
    },

    createComment: async (data: {
        boardId: number;
        userId: number;
        content: string;
    }): Promise<CommentItem> => {
        const token = localStorage.getItem('token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const response = await axios.post('/api/comment', data, { headers });
        return response.data;
    },

    deleteComment: async (commentId: number, userId: number): Promise<void> => {
        const token = localStorage.getItem('token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        await axios.delete(`/api/comment/${commentId}`, {
            headers,
            params: { userId },
        });
    },
};
